import { resolveGuestLanguage } from './guestLanguage';

export const getDetectedGuestLanguage = () =>
  resolveGuestLanguage(
    navigator.languages?.length ? navigator.languages : [navigator.language],
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

const deviceLanguage = { languageTag: getDetectedGuestLanguage() };
export default deviceLanguage;
